<!-- table skeleton loader -->
<div *ngIf="isFetchingPortfolioList$ | async" class="mt-[0.94rem]">
    <app-table-skeleton-loader></app-table-skeleton-loader>
  </div>
  

<!-- Table -->
<div
  *ngIf="!(isFetchingPortfolioList$ | async)"
  class="rounded-lg border border-solid border-mango-gray200 bg-white"
>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full divide-y divide-gray-300">
          <thead class="bg-gray-50">
            <tr>
              <th
                scope="col"
                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
              >
                S/N
              </th>
              <th
                scope="col"
                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
              >
                Description
              </th>
              <th
                scope="col"
                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
              >
                Value Local
              </th>

              <th
                scope="col"
                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Fund Name
              </th>
              <th
                scope="col"
                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                CCY
              </th>

              <th
                scope="col"
                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Account Type
              </th>

              <th
                scope="col"
                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Asset Class
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            <!-- Add table body here -->
            @for (portfolio of porfolioList; track $index) {
              <tr>
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  {{ $index + 1 }}
                </td>
                <!-- Description -->
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  {{ portfolio.description || '—' }}
                </td>

                <!-- Value Local  -->
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  @if (portfolio.ccy === 'NGN') {
                    ₦
                    {{ (portfolio.valueLocal / 100 | number: '1.2-2') || '—' }}
                  } @else {
                    $
                    {{ (portfolio.valueLocal / 100 | number: '1.2-2') || '—' }}
                  }
                </td>

                <!-- Fund Name -->
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  {{ portfolio.fundName || '—' }}
                </td>

                <!-- Currency -->
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  {{ portfolio.ccy || '—' }}
                </td>

                <!-- Account Type -->
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  {{ portfolio.AccountType || '—' }}
                </td>

                <!-- CLR  -->
                <td
                  class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                >
                  {{ portfolio.clr || '—' }}
                </td>
              </tr>
            }
          </tbody>
        </table>

        <div
          *ngIf="
            porfolioList.length === 0 && !(isFetchingPortfolioList$ | async)
          "
          class="flex w-full px-6 pb-6 pt-6"
        >
          No portfolio data found for this account.
        </div>

        <!-- <div
          *ngIf="isFetchingPortfolioList$ | async"
          class="flex w-full px-6 pb-6 pt-6"
        >
          ...Fetching the portfolio for this account. Please wait.
        </div> -->
      </div>
    </div>
  </div>
</div>